module.exports = __webpack_public_path__ + "TRN Brochure.pdf";